export default __webpack_public_path__ + "static/media/frame-card-warchief.a775b587.png";